import React from "react";
import { Route, Switch } from "react-router-dom"
import Layout from "./Layout"
import './App.css'
function App() {
  return (
    <div>
      <Switch>
        <Route path="/">
          <Layout />
        </Route>
      </Switch>
    </div>
  )

}

export default App;
